import { authResource } from './Auth';
export const OrganizationEncryptionDRMResource = authResource({
    path: '/organizations/:organizationId/encryptions/drm/:drmId?',
    schema: {}
}).extend('partialUpdate', {
    body: {
        encryptionGUIDs: [],
        copyAllowed: false,
        forwardAllowed: false,
        printAllowed: false,
        saveAllowed: false
    },
    schema: undefined
});
